import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

/* For when we need to inject some "static" button to display with text and a link */
class HardCodedContent extends React.Component {
  render() {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column textAlign={this.props.align}>
            {this.props.children}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

HardCodedContent.propTypes = {
  align: PropTypes.string
};

HardCodedContent.defaultProps = {
  align: 'left'
};

export default HardCodedContent;


// WEBPACK FOOTER //
// ./public/components/forms/HardCodedContent.jsx